module.exports = "data:image/gif;base64,R0lGODlhEAAQAIABAAAAAP///yH5BAEAAAEALAAAAAAQABAAAAIijI+pAQ2L3pGQMmisXXKnFnkX92FjZmpptE4tim3O7JhYAQA7"